import {DefaultTimelineMetadata} from "../../../../../util/types";
import {findMetadata, isDateAfter, isDateBefore, isDateSame, isDateSameOrAfter} from "../../../../../util/helpers";
import Card from "./Card";
import {formatDateText} from "../../../../../util/formatter";
import IconRocket from "../../../../icons/IconRocket.tsx";

export default function OnlineCard({metadata}: { metadata: DefaultTimelineMetadata[] }) {
    const active_date = findMetadata('product_instance_status_active_date', metadata);
    const is_online: boolean = isDateSameOrAfter(active_date);

    const getTitle = () : string => {
        if (isDateBefore(active_date)) {
            return 'Online senest kl. 16';
        }
        if (isDateSame(active_date)) {
            return 'Online senest kl. 16';
        }
        if (isDateAfter(active_date)) {
            return 'Online';
        }
        return 'Online';
    }

    return <Card
        done={is_online}
        position={'end'}
        title={getTitle()}
        icon={IconRocket}
    >
        {active_date ? (
                <>
                    {isDateBefore(active_date) &&
                    <>
                        <p>Dit internet forventes at være klar</p>
                        <p className={'date'}>{formatDateText(active_date)}</p>
                    </>
                    }
                    {isDateSame(active_date) &&
                    <>
                        <p>Dit internet bliver klar i dag.</p>
                        <p className={'date'}>{formatDateText(active_date)}</p>
                    </>
                    }
                    {isDateAfter(active_date) &&
                    <>
                        <p>Dit internet blev aktiveret</p>
                        <p className={'date'}>{formatDateText(active_date)}</p>
                    </>
                    }
                </>
            ) :
            <p className={'online'}>
                Vi afventer datoen af vores underleverandør.
            </p>
        }
    </Card>
}
